import React, { useState } from 'react'
import Hero from './home/Hero'
//import Featured from './home/Featured'
import ProductGrid from './home/ProductGrid'
import WhyBuySection from './home/WhyBuySection'
import Vegetables from './home/Vegetables'
import Banner from './home/Banner'
import Bestseller from './home/Bestseller'
import Fact from './home/Fact'
import Testimonial from './testimonial/Testimonial'
import SEO from './SEO'

const faqs = [
    {
        question: 'How are beanies made?',
        answer: 'Beanies are typically knitted or woven using materials like wool, cotton, or acrylic, then stitched and shaped into a snug-fitting cap.',
    },
    {
        question: 'Who made beanies?',
        answer: 'Beanies don’t have a single creator; they evolved over time from early knitted caps worn by workers and sailors for warmth.',
    },
    {
        question: 'Where to buy blank beanies?',
        answer: 'Blank beanies can be purchased from online wholesalers, apparel suppliers, custom clothing stores, and bulk headwear retailers.',
    },
    {
        question: 'Are beanies caps/hats?',
        answer: 'Yes, beanies are a type of hat (a close-fitting knitted cap worn for warmth and style.',
    },
]

const Home = () => {
    const [openFaq, setOpenFaq] = useState(0)

    return (
        <>
            <Hero />

            <SEO
                title='Blank Beanies'
                description='Blank Beanies'
                keywords='Blank Beanies'
            />

            <ProductGrid categoryId="all" categoryName="All Products" />

            {/* New Section of humanized content */}
            <div className="relative overflow-hidden rounded-[28px] bg-[#1e242a] py-14 md:py-20 lg:py-24 md:rounded-[40px]">
                <div className="absolute inset-0 bg-gradient-to-br from-[#1e242a] via-[#37404a] to-[#5f6870]" />
                <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-white/10 blur-3xl" />
                <div className="absolute -bottom-28 -left-28 h-80 w-80 rounded-full bg-[#e5e8e6]/10 blur-3xl" />

                <div className="relative z-10 container mx-auto px-4 sm:px-6 md:px-10">
                    <div className="mx-auto max-w-5xl text-center">
                        <h2 className="mx-auto mt-6 max-w-4xl leading-tight">
                            <span className="block text-3xl font-extrabold tracking-tight text-white sm:text-4xl md:text-5xl lg:text-6xl">
                                Blank Beanies That Combine Comfort, Style, and Custom Readiness
                            </span>

                            <span className="mx-auto mt-5 block max-w-3xl text-base font-medium leading-relaxed text-[#e5e8e6]/90 sm:text-lg md:text-xl">
                                Premium blank beanies Designed for Brands, Teams, and Everyday Use
                            </span>
                        </h2>

                        <p className="mx-auto mt-8 max-w-3xl text-sm leading-relaxed text-white/80 sm:text-base md:mt-10 md:text-lg">
                            If you're searching for blank beanies, you've likely realized how difficult it is to find options that balance quality, comfort, and flexibility.
                        </p>

                        <div className="mx-auto mt-7 max-w-4xl md:mt-8">
                            <ul className="grid grid-cols-1 gap-4 text-left md:grid-cols-3">
                                <li className="rounded-2xl border border-white/10 bg-white/10 p-5 text-sm leading-relaxed text-white/90 shadow-sm backdrop-blur-sm md:text-base">
                                    Some feel too thin.
                                </li>

                                <li className="rounded-2xl border border-white/10 bg-white/10 p-5 text-sm leading-relaxed text-white/90 shadow-sm backdrop-blur-sm md:text-base">
                                    Others lose form with a couple of uses.
                                </li>

                                <li className="rounded-2xl border border-white/10 bg-white/10 p-5 text-sm leading-relaxed text-white/90 shadow-sm backdrop-blur-sm md:text-base">
                                    And most of them do not lend themselves to customization.
                                </li>
                            </ul>
                        </div>

                        <p className="mx-auto mt-8 max-w-3xl text-sm leading-relaxed text-white/80 sm:text-base md:text-lg">
                            This is where product selection is important.
                        </p>

                        <p className="mx-auto mt-4 max-w-3xl text-sm leading-relaxed text-white/80 sm:text-base md:text-lg">
                            High-quality blank beanies for sale should not only look good but also perform well over time. They must embrace their structure, be comfortable with it and uphold branding requirements without jeopardy.
                        </p>
                    </div>
                </div>
            </div>

            {/* STEP BY STEP SECTION */}
            <section className="relative overflow-hidden bg-[#f5f6f5] py-14 sm:py-16 md:py-20 lg:py-24">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-28 -right-28 h-72 w-72 rounded-full bg-[#1e242a]/5 blur-3xl"></div>
                    <div className="absolute -bottom-32 -left-32 h-80 w-80 rounded-full bg-[#37404a]/10 blur-3xl"></div>
                </div>

                <div className="relative z-10 container mx-auto px-4 sm:px-6 md:px-10">
                    <div className="mx-auto mb-10 max-w-6xl text-center md:mb-14">
  <h2 className="mt-5 whitespace-normal text-2xl font-extrabold leading-tight tracking-tight text-[#1e242a] sm:text-3xl md:text-4xl lg:whitespace-nowrap lg:text-5xl">
    Make My Own Beanies–Step by Step
  </h2>

                        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
                            Follow a clear and simple process to customize your blank beanies with confidence.
                        </p>
                    </div>

                    <div className="relative mx-auto max-w-5xl">
                        <div className="hidden md:block absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-[#1e242a]/15"></div>

                        <div className="space-y-5 md:space-y-8">
                            {[
                                'Select your favorite blank beanie style, material and color.',
                                'Choose the purpose (use as an individual, as a brand, as a team or to resell)',
                                'Choose a customization method (embroidery, patch, printing or sublimation)',
                                'Create or post your design, logo or artwork.',
                                'Put the design on the beanie with a preview or mockup tool.',
                                'Check placement, sizes, colours and so on.',
                                'Select your design and place your order.',
                                'Take your own beansies and prepare to use or distribute.',
                            ].map((text, index) => {
                                const isEven = index % 2 === 0

                                return (
                                    <div
                                        key={index}
                                        className="relative grid grid-cols-1 items-center md:grid-cols-2 md:gap-12"
                                    >
                                        {isEven ? (
                                            <>
                                                <div className="md:text-right">
                                                    <div className="rounded-3xl border border-[#1e242a]/10 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl md:p-6">
                                                        <p className="text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
                                                            {text}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="hidden md:block"></div>
                                            </>
                                        ) : (
                                            <>
                                                <div className="hidden md:block"></div>
                                                <div>
                                                    <div className="rounded-3xl border border-[#1e242a]/10 bg-[#e5e8e6] p-5 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl md:p-6">
                                                        <p className="text-sm leading-relaxed text-[#1e242a] sm:text-base md:text-lg">
                                                            {text}
                                                        </p>
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        <span className="hidden md:flex absolute left-1/2 top-1/2 h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full border border-[#1e242a]/10 bg-[#1e242a] text-sm font-bold text-white shadow-lg">
                                            {String(index + 1).padStart(2, '0')}
                                        </span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>

            {/* <Featured /> */}

            <WhyBuySection />

            {/* FAQ SECTION */}
            <section className="relative overflow-hidden bg-[#f5f6f5] py-12 sm:py-14 md:py-16 lg:py-20">
                <div className="absolute inset-0 pointer-events-none">
                    <div className="absolute -top-28 -right-28 h-72 w-72 rounded-full bg-[#1e242a]/5 blur-3xl"></div>
                    <div className="absolute -bottom-32 -left-32 h-80 w-80 rounded-full bg-[#37404a]/10 blur-3xl"></div>
                </div>

                <div className="relative z-10 container mx-auto px-4 sm:px-6 md:px-10">
                    <div className="mx-auto mb-8 max-w-4xl text-center md:mb-12">
                        <span className="inline-flex rounded-full border border-[#1e242a]/10 bg-white px-5 py-2 text-xs font-bold uppercase tracking-[0.2em] text-[#37404a] shadow-sm">
                            Help Center
                        </span>

                        <h2 className="mt-5 text-3xl font-extrabold leading-tight tracking-tight text-[#1e242a] sm:text-4xl md:text-5xl lg:text-6xl">
                            FAQs
                        </h2>

                        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-[#5f6870] sm:text-base md:text-lg">
                            Quick answers to common questions about blank beanies.
                        </p>
                    </div>

                    <div className="mx-auto max-w-4xl space-y-4">
                        {faqs.map((faq, index) => {
                            const isOpen = openFaq === index

                            return (
                                <div
                                    key={index}
                                    className="overflow-hidden rounded-2xl border border-[#1e242a]/10 bg-white shadow-sm transition-all duration-300 hover:shadow-lg"
                                >
                                    <button
                                        type="button"
                                        onClick={() => setOpenFaq(isOpen ? null : index)}
                                        className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left sm:px-6 md:px-7"
                                        aria-expanded={isOpen}
                                    >
                                        <span className="text-base font-bold leading-snug text-[#1e242a] sm:text-lg md:text-xl">
                                            {index + 1}: {faq.question}
                                        </span>

                                        <span
                                            className={`flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-[#e5e8e6] text-xl font-bold text-[#1e242a] transition-transform duration-300 ${
                                                isOpen ? 'rotate-45' : 'rotate-0'
                                            }`}
                                        >
                                            +
                                        </span>
                                    </button>

                                    <div
                                        className={`grid transition-all duration-300 ease-in-out ${
                                            isOpen
                                                ? 'grid-rows-[1fr] opacity-100'
                                                : 'grid-rows-[0fr] opacity-0'
                                        }`}
                                    >
                                        <div className="overflow-hidden">
                                            <p className="px-5 pb-5 text-sm leading-relaxed text-[#5f6870] sm:px-6 sm:text-base md:px-7 md:text-lg">
                                                {faq.answer}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>

            {/* <Vegetables /> */}
            {/* <Banner /> */}
            {/* <Bestseller /> */}
            {/* <Fact /> */}
            {/* <Testimonial /> */}
        </>
    )
}

export default Home